<template>
    <gi-form
        v-if="form"
        ref="form"
        :form="form"
        :on-submit-fn="onSubmitFn"
        :history="history"
        :hide-actions="hideActions"
        @success="onSuccess"
        @error="onError"
        @form-error="onFormError"
        @load-history="onLoadHistory"
        @start-history-autosave="startHistoryAutosave"
        @stop-history-autosave="stopHistoryAutosave"
    >
        <template v-if="!hideHeader" #header>
            <app-page-header class="mb-4" />
        </template>
        <template #fields="{ loading }">
            <field-group-organisation
                ref="organisation"
                :value="form"
                :loading="loading"
                require-company-info
                @input="setFormData"
            />

            <v-row :no-gutters="$vuetify.breakpoint.smAndDown" class="stacked">
                <v-col md="4" cols="12">
                    <field-adviser
                        ref="parent_id"
                        v-model="form.parent_id"
                        :disabled="loading"
                        :label="$t('parent_adviser')"
                    />
                </v-col>
                <v-col md="4" cols="12">
                    <field-string
                        ref="auth_client_id"
                        v-model="form.auth_client_id"
                        :disabled="loading"
                        :label="$t('auth_client_id')"
                    />
                </v-col>
                <v-col md="4" cols="12">
                    <field-string
                        ref="auth_client_secret"
                        v-model="form.auth_client_secret"
                        :disabled="loading"
                        :label="$t('auth_client_secret')"
                    />
                </v-col>
            </v-row>

            <app-alert alert-type="info" class="mb-7">
                <h3>Custom Registration</h3>
                <p class="mb-8">
                    These settings control the behavior of the registration of new users. Do not change them unless you
                    know what you’re doing.
                </p>

                <field-string
                    ref="custom_app_url"
                    v-model="form.custom_app_url"
                    :disabled="loading"
                    :label="$t('custom_app_url')"
                />

                <field-toggle
                    ref="new_registrations_advised"
                    v-model="form.new_registrations_advised"
                    :disabled="loading"
                    :required="form.custom_app_url ? true : false"
                    label="Default advised setting"
                    :default-value="false"
                />

                <field-user
                    v-if="isEditing"
                    ref="new_registrations_contact_id"
                    v-model="form.new_registrations_contact_id"
                    :disabled="loading"
                    :required="form.custom_app_url ? true : false"
                    label="Default primary contact"
                    :filters="form.id ? { role_in_organisation: `${form.id}` } : null"
                />

                <field-public-adviser
                    ref="public_adviser_id"
                    v-model="form.public_adviser_id"
                    :disabled="loading"
                    label="Link to public adviser"
                />
            </app-alert>

            <app-alert alert-type="error" class="mb-7">
                <h3 class="error--text text--darken-4">DANGER - Do not change without checking with the tech team</h3>
                <p class="mb-0">
                    The following settings control the relationship between the adviser and the platform.
                </p>
                <p class="mb-8">
                    Changing these settings could prevent advisers and their clients from accessing the platform.
                </p>

                <field-string
                    ref="auth_client_id"
                    v-model="form.auth_client_id"
                    :disabled="loading"
                    :label="$t('auth_client_id')"
                />

                <field-string
                    ref="auth_client_secret"
                    v-model="form.auth_client_secret"
                    :disabled="loading"
                    :label="$t('auth_client_secret')"
                />
            </app-alert>
        </template>
        <template v-if="prependCancelButton" #prepend-actions>
            <app-button-cancel @click="onCancel" />
        </template>
    </gi-form>
</template>

<script>
import form from '@/mixins/form';
import history from '@/mixins/history';
import { Adviser } from '@/models';

export default {
    name: 'CreateAdviser',
    components: {
        GiForm: () =>
            import(
                /* webpackChunkName: "forms" */
                '@/components/forms/Form'
            ),
        FieldGroupOrganisation: () =>
            import(
                /* webpackChunkName: "fields" */
                '@/components/fields/groups/Organisation'
            ),
        FieldAdviser: () =>
            import(
                /* webpackChunkName: "fields" */
                '@/components/fields/Adviser'
            ),
        FieldPublicAdviser: () =>
            import(
                /* webpackChunkName: "fields" */
                '@/components/fields/PublicAdviser'
            ),
        FieldUser: () =>
            import(
                /* webpackChunkName: "fields" */
                '@/components/fields/User'
            )
    },
    mixins: [form, history],
    data: () => ({
        id: 'CreateAdviser',
        model: Adviser
    })
};
</script>
